module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_voice_recording-a8ea60c83e1754e596675875d60c16fb.svg";